import React from "react";
import "./pages.css";
import "./pagesResponsiveStylesheet.css";
import Icon from "../Assets/IconLibrary/Icon";
import LottieAnimation from "../Assets/Lotties/LottieAnimation";
import Popup from "reactjs-popup";
import HubspotForm from "react-hubspot-form";
import PianoLoading from "../Assets/Loading/PianoLoading";
import HeadSection from "../Components/HeadSection/HeadSection";
import Button from "../Components/Buttons/Button";

import PricingPlanBackground3 from "../Assets/Images/Illustrations/pricingplanBackground.svg"
import PricingPlanBackground1 from "../Assets/Images/Illustrations/pricingPlanBackground2.svg"
import PricingPlanBackground2 from "../Assets/Images/Illustrations/pricingplanMiddleBackground.svg"
import MainBackground from "../Components/Backgrounds/MainBackground";
import {HubspotInfo} from "../api/ApiCallMethod";

class PricingPlan extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            pricingPlanList:[
                {
                    Name:           "Free",
                    Price:          "$0",
                    Unit:           "per user",
                    Message:        "1,000",
                    Document:       "10",
                    Chatbot:        "10",
                    Storage:        "1GB",
                    WebEmbedding:   "Unlimited",
                    Support:        ["-"],
                    Background:     PricingPlanBackground1,
                    Button:         "custom"
                },
                {
                    Name:           "Starter",
                    Price:          "$99",
                    Unit:           "per user",
                    Message:        "10,000",
                    Document:       "Unlimited",
                    Chatbot:        "Unlimited",
                    Storage:        "10GB",
                    WebEmbedding:   "Unlimited",
                    Support:        ["9 am - 5 pm", "Monday-Friday"],
                    Background:     PricingPlanBackground2,
                    Button:         "custom"
                },
                {
                    Name:           "Business",
                    Price:          "$999",
                    Unit:           "per user",
                    Message:        "100,000",
                    Document:       "Unlimited",
                    Chatbot:        "Unlimited",
                    Storage:        "100GB",
                    WebEmbedding:   "Unlimited",
                    Support:        ["24 hours", "7 days"],
                    Background:     PricingPlanBackground2,
                    Button:         "primary"
                }
            ],

            propertiesList:[
                {Name: "Messages", Value:"Message"},
                {Name: "Documents", Value:"Document"},
                {Name: "Chatbots", Value:"Chatbot"},
                {Name: "Storage", Value:"Storage"},
                {Name: "Web Embedding", Value:"WebEmbedding"},
                {Name: "Support", Value:"Support"},
            ],

            launchingSoonPopup: false,
            thankyouPopup: false,

        }
    }

    contactForPrice = () =>{
        // window.open("https://calendly.com/blinx_sales", "_blank")
        // this.setState({
        //     contactUsPopup: true
        // })
        this.setState({
            contactUsPopup: true
        })
    }

    getStartedWithPrice = () =>{
        // let productUrl = DefaultParameters().ProductURL;
        // productUrl += DefaultParameters().SignupRoute;
        // window.open(productUrl, '_blank');
        this.setState({
            contactUsPopup: true
        })

    }


    submitForm = () =>{
        this.setState({
            contactUsPopup: false,
            thankyouPopup: true,
        })
    }

    closeContactUsForm = () =>{
        this.setState({
            contactUsPopup: false,
        })
    }
    closeThankyouPopup = () =>{
        this.setState({
            thankyouPopup: false,
        })
    }

    render() {
        let {propertiesList, pricingPlanList} = this.state;
        return (
            <div className='anygen-pricing-plan-layout'>
                <HeadSection keyword={"pricing"}/>
                <div className="pricing-plan-body">

                    <div className="pricing-plan-card-list">
                        {
                            pricingPlanList.map((plan,pid)=>
                                <div className="pricing-plan-card">
                                    <img src={plan.Background} alt={""} className="pricing-plan-card-background"/>
                                    <div className="pricing-plan-card--header">
                                        <h3 className="pricing-plan-name">
                                            {plan.Name}
                                        </h3>
                                        <div className="pricing-plan-price-info">
                                            <h2 className="default-header-style pricing-plan-price">
                                                {plan.Price}
                                            </h2>
                                            <div className="pricing-plan-unit">
                                                per month<br/>per person
                                            </div>
                                        </div>

                                        {/*<button className="pricing-plan-card-cta-btn"*/}
                                        {/*        onClick={this.getStartedWithPrice.bind(this)}>*/}
                                        {/*    /!*{pid === 2? "Contact Us": "Get Started"}*!/*/}
                                        {/*    Get Started*/}
                                        {/*</button>*/}
                                    </div>
                                    <div className="pricing-plan-card-body">
                                        {
                                            propertiesList.map((property, pid)=>
                                                <div className="pricing-plan-card-info-row">
                                                    <div className="pricing-plan-card-info-row--label">
                                                        {property.Name}
                                                    </div>

                                                    {
                                                        property.Value === "Support"?
                                                            <div className="pricing-plan-card-info-row--value">
                                                                {
                                                                    plan[property.Value].map((res)=>
                                                                        <>
                                                                            {res}
                                                                            <br/>
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                            :
                                                            <div className="pricing-plan-card-info-row--value">
                                                                {plan[property.Value]}
                                                                {
                                                                    property.Value === "Message" &&
                                                                    <div className="pricing-plan-card-label">
                                                                        per month
                                                                    </div>
                                                                }
                                                            </div>
                                                    }

                                                </div>
                                            )
                                        }


                                    </div>
                                    <div className="pricing-plan-card-button">
                                        <Button type={plan.Button} onClick={this.getStartedWithPrice.bind(this)} width={"180px"} height={"40px"}>
                                            Get Started
                                        </Button>
                                    </div>

                                </div>
                            )
                        }
                        <div className="pricing-plan-card">
                            <img src={PricingPlanBackground3} alt={""} className="pricing-plan-card-background"/>

                            <div className="pricing-plan-card--header">
                                <h3 className="pricing-plan-name">
                                    Enterprise
                                </h3>
                                <div className="pricing-plan-price-info">
                                    <h2 className="default-header-style pricing-plan-price">
                                        Custom
                                    </h2>
                                </div>
                                {/*<button className="pricing-plan-card-cta-btn"*/}
                                {/*        onClick={this.contactForPrice.bind(this)}>*/}
                                {/*    /!*{pid === 2? "Contact Us": "Get Started"}*!/*/}
                                {/*    Contact Us*/}
                                {/*</button>*/}
                            </div>
                            <div className="pricing-plan-card-body">
                                <div className="pricing-plan-card-info-row">
                                    <Icon name="check_circle" colorList={["black"]} className="pricing-plan-card-icon"/>
                                    <div className="pricing-plan-card-info-row--value">
                                        Expert Advisory
                                    </div>
                                </div>

                                <div className="pricing-plan-card-info-row">
                                    <Icon name="check_circle" colorList={["black"]} className="pricing-plan-card-icon"/>
                                    <div className="pricing-plan-card-info-row--value">
                                        Dedicated Support
                                    </div>
                                </div>
                                <div className="pricing-plan-card-info-row">
                                    <Icon name="check_circle" colorList={["black"]} className="pricing-plan-card-icon"/>
                                    <div className="pricing-plan-card-info-row--value">
                                        Support 24 hours, 7 days
                                    </div>
                                </div>
                            </div>

                            <div className="pricing-plan-card-button">
                                <Button onClick={this.contactForPrice.bind(this)} width={"180px"} height={"40px"}>
                                    Contact Us
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>

                <Popup contentStyle={{
                    background: "transparent",
                    padding: 0,
                    border:"none",
                    borderRadius:"none",
                }}
                       open={this.state.launchingSoonPopup}
                       closeOnDocumentClick={false}
                       lockScroll={true}>
                    <div className="launching-soon-popup">
                        <button className="close-popup-button" onClick={()=>this.setState({launchingSoonPopup: false})}>
                            <Icon name="close"/>
                        </button>

                        <div className="launching-soon-header">
                            We will be launching soon!
                        </div>
                        <div className="launching-soon-body">
                            <LottieAnimation lotti={"LaunchingSoon"}/>
                        </div>
                    </div>
                </Popup>


                <Popup contentStyle={{
                    background: "transparent",
                    padding: 0,
                    border: "none",
                    borderRadius: "none",
                }}
                       open={this.state.contactUsPopup}
                       closeOnDocumentClick={false}
                       lockScroll={true}>
                    <div className="contact-us-popup-container">
                        <div className="contact-us-popup">
                            <div className="contact-us-popup-inner-division">
                                <MainBackground/>
                                <div className="contact-us-title">
                                    Contact Us
                                </div>
                                <button className="contact-us-close-btn" onClick={this.closeContactUsForm.bind(this)}>
                                    <Icon name="close" colorList={["white"]}/>
                                </button>

                                <div className="contact-us-form-container">

                                    <HubspotForm
                                        portalId={HubspotInfo.HubspotPortalID}
                                        formId={HubspotInfo.PricingPlanFormID}
                                        onSubmit={() => this.submitForm.bind(this)}
                                        onReady={() => this.submitForm.bind(this)}
                                        cssRequired={""}
                                        cssClass={"contact-us-form"}
                                        submitButtonClass={"contact-us-button"}
                                        loading={<PianoLoading/>}
                                    />
                                </div>



                            </div>
                        </div>
                    </div>

                </Popup>


                <Popup contentStyle={{
                    width: "auto",
                    background: "transparent",
                    padding: 0,
                    border: "none"
                }}
                       open={this.state.thankyouPopup}
                       closeOnDocumentClick={false}
                       lockScroll={false}>

                    <div className="email-send-popup">
                        <button onClick={this.closeThankyouPopup.bind(this)}
                                className="email-send-close-btn">
                            <Icon name={"close"}/>
                        </button>
                        <div className="email-send-image success">

                            <LottieAnimation lotti={"SuccessMark"}/>
                        </div>
                        <div className="email-send-text-title success">
                            Thank you!
                        </div>
                        <div className="email-send-text-body">

                            Thank you for reaching out to us. We will contact you soon.
                        </div>
                    </div>

                </Popup>
            </div>
        );
    }
}

export default PricingPlan;